import React from 'react'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import EventRepeatIcon from '@material-ui/icons/Loop'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'
import EditAvailabilityFormDialog from '../availability-manager/edit-availability-form-dialog'
import { daysOfWeek } from '../availability-manager/constants'
import { dayNames, formatTime12 } from './utils'

const useStyles = makeStyles(theme => ({
  card: {
    minWidth: 260,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.25, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': { borderBottom: 'none' },
  },
  rowLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  iconAvailable: { color: '#4CAF50', fontSize: 18 },
  iconUnavailable: { color: theme.palette.text.secondary, fontSize: 18 },
  hoursLabel: {
    color: theme.palette.text.secondary,
    fontVariantNumeric: 'tabular-nums',
  },
  off: {
    color: theme.palette.text.secondary,
  },
}))

const formatTimeRange = timeSlots => {
  if (!timeSlots || timeSlots.length === 0) return null
  return timeSlots
    .map(ts => `${formatTime12(ts.startTime)}–${formatTime12(ts.endTime)}`)
    .join(', ')
}

const aggregateByDay = timeSlots =>
  daysOfWeek.reduce((acc, d) => {
    acc[d] = (timeSlots || []).filter(ts => ts.day === d)
    return acc
  }, {})

const RecurringHoursSidebar = ({ availability, onSuccess }) => {
  const classes = useStyles()
  const byDay = aggregateByDay(availability.timeSlots)

  return (
    <Card variant="outlined" className={classes.card}>
      <Box className={classes.header}>
        <Box className={classes.headerLeft}>
          <EventRepeatIcon fontSize="small" color="action" />
          <Typography variant="subtitle1">
            <Box component="span" fontWeight={500}>
              Recurring Weekly Hours
            </Box>
          </Typography>
        </Box>
        <EditAvailabilityFormDialog
          trigger={
            <IconButton size="small" aria-label="edit recurring hours">
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          }
          initialTimeSlots={availability.timeSlots}
          coachFacilityId={availability.coachFacility?.id}
          facilityTimezone={availability.timeZone}
          onSuccess={onSuccess}
        />
      </Box>
      {daysOfWeek.map((day, idx) => {
        const slots = byDay[day]
        const isAvailable = slots.length > 0
        return (
          <Box key={day} className={classes.row}>
            <Box className={classes.rowLeft}>
              {isAvailable ? (
                <CheckIcon className={classes.iconAvailable} />
              ) : (
                <CloseIcon className={classes.iconUnavailable} />
              )}
              <Typography variant="body2">{dayNames[idx]}</Typography>
            </Box>
            {isAvailable ? (
              <Typography variant="body2" className={classes.hoursLabel}>
                {formatTimeRange(slots)}
              </Typography>
            ) : (
              <Typography variant="body2" className={classes.off}>
                Off
              </Typography>
            )}
          </Box>
        )
      })}
    </Card>
  )
}

export default RecurringHoursSidebar
